import type { Document as ContentfulDocument } from '@contentful/rich-text-types';

/** Input for {@link downloadDocumentPdf}. */
export type DocumentPdfPayload = {
  pages: ContentfulDocument[];
  fileName: string;
  /** Optional PDF metadata title. See {@link RenderDocumentPdfInput.title}. */
  title?: string;
};

/**
 * Render Contentful documents to PDF in the browser and trigger an auto-download.
 * Dynamically imports `@react-pdf/renderer` so it only loads on first call.
 */
export const downloadDocumentPdf = async (
  payload: DocumentPdfPayload,
): Promise<void> => {
  const { renderDocumentPdfToBlob } = await import(
    '@lib/contentful-pdf/render-document-pdf'
  );

  const blob = await renderDocumentPdfToBlob({
    pages: payload.pages,
    title: payload.title,
  });
  const objectUrl = URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = payload.fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};
